<template>
  <Basic>
    <div class="grid grid--container">
      <div class="row">
        <div class="col col--lg-9 col--centered">
          <h1 class="basic__title">GDPR Addendum</h1>
          <div class="legal-content">
            <p><strong>Source:</strong> Signup</p>
            <p></p>
            <p>
              <strong>Personal Data:</strong>
            </p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Categorization</li>
              <li>IP address</li>
            </ul>
            <p>If signing up with Google:</p>
            <ul>
              <li>Full Name</li>
              <li>Email address</li>
            </ul>
            <p>If signing up with Facebook:</p>
            <ul>
              <li>Full Name</li>
              <li>Email address</li>
            </ul>
            <p>
              <strong>Reason:</strong> To allow login to our service and contact
              you to learn more about our service
            </p>
            <p>
              <strong>Handling:</strong> Securely stored in MongoDB (ran in
              AWS). Only partners have direct access.
            </p>
            <p>
              <strong>Disposal:</strong> When account is deleted information is
              removed
            </p>

            <hr />

            <p><strong>Source:</strong> Instagram Authorization</p>
            <p></p>
            <p>
              <strong>Personal Data:</strong>
            </p>
            <ul>
              <li>Full Name</li>
              <li>Instagram Username</li>
              <li>Profile picture</li>
            </ul>
            <p>
              <strong>Reason:</strong> To allow you to assign Instagram images
              to links
            </p>
            <p>
              <strong>Handling:</strong> Securely stored in MongoDB (ran in
              AWS). Only partners have direct access.
            </p>
            <p>
              <strong>Disposal:</strong> When account is deleted, data is
              removed
            </p>

            <hr />

            <p><strong>Source:</strong> Pro Subscription Signup</p>
            <p>
              <strong>Personal Data:</strong>
            </p>
            <ul>
              <li>Credit card</li>
              <li>Zip code</li>
            </ul>
            <p><strong>Reason:</strong> To allow for payment of subscription</p>
            <p>
              <strong>Handling:</strong> Securely stored by our 3rd party
              payment provider Stripe
            </p>
            <p>
              <strong>Disposal:</strong> On request or when account is deleted
            </p>

            <hr />

            <p><strong>Source:</strong> Support/feedback request</p>
            <p><strong>Personal Data:</strong></p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>IP Address</li>
            </ul>
            <p>
              <strong>Reason:</strong> To reply and support a users support
              request
            </p>
            <p>
              <strong>Handling:</strong> Stored in 3rd party provider Intercom.
              Expires in 9 months for visitors not seen again.
            </p>
            <p><strong>Disposal:</strong> On request</p>

            <hr />

            <p><strong>Source:</strong> Contact form</p>
            <p>
              <strong>Personal Data:</strong>
            </p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>IP address</li>
            </ul>
            <p>
              <strong>Reason:</strong> To reply and support a users support
              request
            </p>
            <p>
              <strong>Handling:</strong> Securely stored in MongoDB (ran in AWS)
            </p>
            <p><strong>Disposal:</strong> On request</p>

            <h2>Sub Processors</h2>
            <p><strong>Google Analytics</strong></p>
            <p>Data:</p>
            <ul>
              <li>Anonymized cookie data</li>
              <li>Session data</li>
            </ul>
            <hr />
            <p><strong>Intercom</strong></p>
            <p>Data:</p>
            <ul>
              <li>Email address</li>
              <li>First Name/Company</li>
              <li>IP Address</li>
              <li>City and Country</li>
              <li>OS and browser info</li>
              <li>Web sessions</li>
            </ul>
            <hr />
            <p><strong>Sentry</strong></p>
            <p>Data:</p>
            <ul>
              <li>Email address</li>
              <li>Application usage statistics</li>
            </ul>
            <hr />
            <p><strong>Stripe</strong></p>
            <p>Data:</p>
            <ul>
              <li>Email address</li>
              <li>Billing details</li>
            </ul>
            <hr />
            <p><strong>Facebook</strong></p>
            <p>Data:</p>
            <ul>
              <li>Anonymized cookie data</li>
            </ul>
            <hr />
            <p><strong>Zerobounce</strong></p>
            <p>Data:</p>
            <ul>
              <li>Email</li>
              <li>IP Address</li>
            </ul>

            <hr />

            <p>
              <strong>Contact Information</strong>
              <br />Email: support@campsite.bio
            </p>
            <p>
              If you are located in the EU, you may also contact our EU
              representative using the following contact details: Instant EU
              GDPR Representative Ltd, Adam Brogden, contact@gdprlocal.com, Tel
              +353 15 549 700, https://grahamsnapsllc.gdprlocal.com/eu, Instant
              EU GDPR Representative Ltd 69 Esker Woods Drive, Lucan Co. Dublin
              Ireland
            </p>
            <p>
              If you are located in the United Kingdom, you may also contact our
              UK representative using the following contact details: GDPR Local
              LTD, Adam Brogden, contact@gdprlocal.com, +441 772 217 800,
              https://grahamsnapsllc.gdprlocal.com/eu, GDPR Local Ltd 1st Floor
              Front Suite 27-29 North Street, Brighton England BN1 1EB
            </p>
          </div>
        </div>
      </div>
    </div>
  </Basic>
</template>

<script>
import defaultOG from '@/assets/default-og';
import Basic from '@/components/basic';

export default {
  head: {
    title: 'GDPR Addendum - Campsite.bio',
    meta: [...defaultOG],
  },

  components: { Basic },
};
</script>

<style lang="scss" scoped></style>
